import { render, staticRenderFns } from "./ImageSkeleton.vue?vue&type=template&id=b156b06a&scoped=true&"
import script from "./ImageSkeleton.vue?vue&type=script&lang=js&"
export * from "./ImageSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b156b06a",
  null
  
)

export default component.exports